import {doStyleOnAllOrderingPages} from "../../blocks/allOrderingProcess";
import {HelperFunctions} from "../../config/helperFunctions";
import {STATES} from "../../config/states";
import {TranslationsManager} from "../../utils/localisationManager";

export class CartThirdStep {
    static EventListeners = {
        'change': CartThirdStep.doLoadOnChange,
    }
    // static doLoadOnShoptetDOMPageContentLoaded() {}
    // static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    // static doLoadOnShoptetDOMContentLoaded() {}
    static doLoadOnChange() {
    }
    static async doInit() {
        doStyleOnAllOrderingPages();
        CartThirdStep.doStyleMisc();
        return true;
    }
    static doStyleMisc() {
        $('body').addClass('in-krok-2');

        $(`
            <a href="${TranslationsManager.doGetStringByLang('REGISTRATION_URL')}" class="btn btn-secondary" title="Nová registrace" rel="nofollow">${TranslationsManager.doGetStringByLang('REGISTRATION_TITLE')}</a>
        `).insertAfter('.ordering-process .box .form-group:nth-child(2) .btn-secondary:first-child');
        // $(
        //     `<p class="required-fields">Povinná pole jsou označena hvězdičkou (*)</p>`
        // ).insertAfter(".co-contact-information > h4");
    }
}
